import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initInfoHoverCards() {
  Alpine.data(
    'infoHoverCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.sw-hovercards');
        if (swiperEl) {
          this.initSwiper(swiperEl);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          spaceBetween: 15,
          loop: false,
          autoplay: {
            delay: 2500,
            disableOnInteraction: true,
          },
          autoHeight: false,
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
              autoHeight: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
            },
            1400: {
              slidesPerView: 4,
            },
          },
        });
      },
    }),
  );
}
